export default __webpack_public_path__ + "static/media/iconDayBed.aecc78d6.svg";